import { MenuItem } from "@mui/material";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import UnpublishListingModal from "../unpublish-listing/unpublish-listing-modal";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

export default function UnpublishListingMenuItem({
  listingUid,
}: {
  listingUid: string;
}) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const { readonly } = useReadonlyContext();

  return (
    <>
      <PermissionGuard
        permissions={[
          {
            name: PermissionsEnum.UNPUBLISH_LISTING,
            level: PermissionLevel.WRITE,
          },
        ]}
      >
        <MenuItem
         disabled={readonly}
          sx={(theme) => ({
            display: "flex",
            gap: theme.nawy.spacing.xs,
            color: theme.nawy.colors.semantic.text.extension.negative,
          })}
          onClick={handleOpen}
        >
          <Trash2 />
          Remove Listing
        </MenuItem>
        <UnpublishListingModal
          listingUid={listingUid}
          open={open}
          setOpen={setOpen}
        />
      </PermissionGuard>
    </>
  );
}
